import { useSnackbar } from 'notistack'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FilterContext } from '../../../../../components/data-grid/context'
import { DeletePurchasePriceDialog } from '../../delete-purchase-price-dialog'
import { isPurchasePriceListFragment } from '../is-purchase-price-list-fragment'
import { Row } from '..'
import { useGridSelection } from '../../../../../components/data-grid/hooks/use-grid-selection'

type Props = {
  isOpen: boolean
  onClose(): void
  refetch(): Promise<unknown>
}

export const DeletePrice = (props: Props) => {
  const { t } = useTranslation(['purchase_prices'])
  const { enqueueSnackbar } = useSnackbar()
  const { filter } = useContext(FilterContext)

  const selectedIdsMap = useGridSelection<number, Row>()
  const selectedSkus = Array.from(selectedIdsMap.values()).map(({ sku }) => sku)

  const onClose = () => {
    props.onClose()
  }

  const onSuccess = (_priceListId: string, skus: string[]) => {
    void props.refetch()

    enqueueSnackbar(
      t('purchase_prices:success_delete_purchase_price_snackbar', {
        count: skus.length,
      }),
    )

    onClose()
  }

  const onError = (_priceListId: string, skus: string[]) => {
    void props.refetch()

    enqueueSnackbar(
      t('purchase_prices:failure_delete_purchase_price_snackbar', {
        count: skus.length,
      }),
      { variant: 'error' },
    )
    onClose()
  }

  const priceListId = isPurchasePriceListFragment(filter?.['priceList']?.value)
    ? filter?.['priceList']?.value.id
    : undefined

  if (!priceListId) {
    return null
  }

  return (
    <DeletePurchasePriceDialog
      open={props.isOpen}
      onClose={onClose}
      priceListId={priceListId}
      productSkus={selectedSkus}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}
